import React, { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

import "../daterangepicker.css";
import "../Usuarios/usuarios.css";
import "../../Forms.css";

import * as api from "helper/helper";
import { Sections } from "../../data/navItem";
import { PermissionsForSection } from "../auth";
import PagedFetch, {
  buildPageButtonsInfo,
  Init,
} from "../../helperFunctions/PagedFetch";
//import ClientesKPITableSmall from "./ClientesKPITableSmall";
import Chart from "react-apexcharts";
import { Singleton } from "helper/tools";

import { format } from "date-fns";
import { es } from "date-fns/locale"; // Or any other locale like 'de', 'es', etc.

export default function ClientesKPICalidadInformacion() {
  const createAsociadosRef = useRef();

  const dateRangeRef = useRef();
  const dateRangeEleRef = useRef();

  const [modalData, setModalData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [permissions, setPermissions] = useState({
    canCreate: true,
    canEdit: true,
    canVerDetalle: true,
  });

  //
  const monthSelectedIndex = useRef();
  const yearSelected = useRef();

  const [chartType] = useState("pie");

  const [series] = useState([44, 55, 13, 43, 22]);

  const [options] = useState({
    chart: {
      width: 380,
      type: "pie",
    },
    labels: ["100%", "75%-99%", "50%-74%", "25%-49%", "0%-24%"],
    dataLabels: {
      enabled: true,
      formatter(val, opts) {
        const name = opts.w.globals.labels[opts.seriesIndex];
        return [name, val.toFixed(1) + "%"];
      },
    },
    title: {
      text: "Calidad de información de Clientes",
      align: "center",
    },
    legend: {
      show: true,
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            show: true,
          },
        },
      },
    ],
  });

  /** FILTERS */
  const [kpiData, setKpiData] = useState([]);

  /** PAGING */
  const [searchCriteria, setSearchCriteria] = useState({
    sortAsc: true,
    sortBy: "sum",
  });
  const [pageButtons, setPageButtons] = useState([Init.Vars.PageButtons]);

  ///start changes CLASS
  const pagingInfoRef = useRef(new PagedFetch());
  const [responsePagingInfo, setResponsePagingInfo] = useState({
    ...Init.Vars.ResponsePagingInfo,
  });

  useEffect(() => {
    console.log("--->");

    const now = new Date();
    const yesterday = new Date(now);
    yesterday.setDate(yesterday.getDate() - 1);
    const daysBack7 = new Date(now);
    daysBack7.setDate(daysBack7.getDate() - 6);
    const daysBack30 = new Date(now);
    daysBack30.setDate(daysBack30.getDate() - 29);

    const thisMonthStart = new Date(now);
    thisMonthStart.setDate(1);
    const thisMonthEnd = new Date(thisMonthStart);
    thisMonthEnd.setMonth(thisMonthEnd.getMonth() + 1);
    thisMonthEnd.setDate(-1);

    const lastMonthStart = new Date(now);
    lastMonthStart.setDate(1);
    lastMonthStart.setMonth(lastMonthStart.getMonth() - 1);
    const lastMonthEnd = new Date(lastMonthStart);
    lastMonthEnd.setMonth(lastMonthEnd.getMonth() + 1);
    lastMonthEnd.setDate(-1);

    const lastYearStart = new Date(now);
    lastYearStart.setDate(1);
    lastYearStart.setMonth(0);
    lastYearStart.setFullYear(lastYearStart.getFullYear() - 1);

    const lastYearEnd = new Date(lastYearStart);
    lastYearEnd.setFullYear(lastYearStart.getFullYear() + 1);
    lastYearEnd.setDate(-1);

    const sameMonthDifAge = new Date(now);
    sameMonthDifAge.setDate(sameMonthDifAge.getFullYear() - 1);

    dateRangeRef.current = new window.daterangepicker(
      dateRangeEleRef.current,
      {
        locale: {
          customRangeLabel: "Rango Personalizado",
        },
        singleDatePicker: false,
        showDropdowns: true,
        showCustomRangeLabel: true,

        minYear: 2020,
        maxYear: now.getFullYear(), // parseInt(moment().format('YYYY'),10)
        ranges: {
          Hoy: [now, now],
          Ayer: [yesterday, yesterday],
          "Ultimos 7 Dias": [daysBack7, now],
          "Ultimos 30 Dias": [daysBack30, now],
          "Este mes": [thisMonthStart, thisMonthEnd],
          "Ultimo mes": [lastMonthStart, lastMonthEnd],
          "Ultimo Año": [lastYearStart, lastYearEnd],
        },
      },
      function (start, end, label) {
        //  var years = 23; //moment().diff(start, 'years');
        //  alert("You are " + years + " years old!");
      },
    );

    /*

    $(function() {

        var start = moment().subtract(29, 'days');
        var end = moment();

        function cb(start, end) {
            $('#reportrange span').html(start.format('MMMM D, YYYY') + ' - ' + end.format('MMMM D, YYYY'));
        }

        $('#reportrange').daterangepicker({
            startDate: start,
            endDate: end,
            ranges: {
                'Today': [moment(), moment()],
                'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                'This Month': [moment().startOf('month'), moment().endOf('month')],
                'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
            }
        }, cb);

        cb(start, end);

    });
    
    */
    /*
    .daterangepicker({
      timePicker: true,
      startDate: 22, //moment().startOf("hour"),
      endDate: 33, //moment().startOf("hour").add(32, "hour"),
      locale: {
        format: "M/DD hh:mm A",
      },
    });*/
    fetchData();

    const newPermissions = PermissionsForSection(Sections.Asociados);
    setPermissions(newPermissions);
  }, []);

  const fetchData = async () => {
    let criteria = searchCriteria;
    /// reset pag info
    pagingInfoRef.current.resetPageInfo();

    criteria = pagingInfoRef.current.buildFetch(criteria);
    searchFetchData(criteria);
  };

  function loadItem(item) {
    if (!permissions.canVerDetalle) return;

    console.log(createAsociadosRef);
    setModalData(item);

    //createAsociadosRef.current.toggleModal();
  }

  /**
   * Search handler
   */

  const searchFetchData = async (criteria) => {
    setIsLoading(true);

    criteria.pageSize = 10;

    const date = new Date();

    criteria.FechaCreacion = date;

    const response = await api
      .clientesKPIDataIntegrityRanges(criteria)
      .catch((error) => {
        toast.error("Error al buscar Clientes.");
        setIsLoading(false);
      });
    if (!response) return;

    /*  let aKpiData = response.data.map((e) => e.total);
    setKpiData(response.data.subset);
    */

    setKpiData(response.data);

    const { totalPages, count, isFirstPage, isLastPage } = response.data;

    const { rangePage, newPageNumber } = buildPageButtonsInfo(response.data);
    pagingInfoRef.current.updatePageNumber(newPageNumber);

    setPageButtons(rangePage);

    setResponsePagingInfo({
      count,
      isFirstPage,
      isLastPage,
      pageNumber: newPageNumber,
      totalPages,
    });

    //  setAsociados(response.data.subset);

    setIsLoading(false);
  };

  const previousPageState = responsePagingInfo.isFirstPage
    ? "disabled disable-paging-btn"
    : "";
  const nextPageState = responsePagingInfo.isLastPage
    ? "disabled disable-paging-btn"
    : "";

  function goPreviousPage() {
    let page = pagingInfoRef.current.pageNumber();
    page -= 1;
    goToPage(page);
  }

  function goNextPage() {
    let page = pagingInfoRef.current.pageNumber();
    page += 1;
    goToPage(page);
  }

  function goToPage(pageNumber) {
    let criteria = searchCriteria;
    pagingInfoRef.current.updatePageNumber(pageNumber);
    criteria = pagingInfoRef.current.buildFetch(criteria);
    searchFetchData(criteria);
  }

  function handleSortChange({ sortBy, sortAsc }) {
    if ((sortBy?.length ?? 0) === 0) {
      return;
    }
    let criteria = searchCriteria;
    criteria["sortBy"] = sortBy;
    criteria["sortAsc"] = sortAsc === "asc";

    setSearchCriteria(criteria);

    /// reset pag info
    pagingInfoRef.current.resetPageInfo();
    criteria = pagingInfoRef.current.buildFetch(criteria);
    searchFetchData(criteria);
  }

  return (
    <>
      <div className="">
        <div className="bd-example-row1">
          <div className="row">
            <div
              className="col card1 recent-sales overflow-auto"
              style={{
                backgroundColor: "transparent",
                borderRadius: "0px",
                marginBottom: "30px",
              }}
            >
              <div className="p-3 border bg-primary text-light report-card-title">
                <span>
                  Calidad de Información
                  <small className="text-muted"></small>
                </span>
              </div>
            </div>
          </div>
          {/*<div className="row">
            <nav
              aria-label="Page navigation example"
              style={{ marginRight: "0px" }}
            >
              <ul
                className="pagination justify-content-end"
                style={{ marginBottom: "0px" }}
              >
                <li
                  className={`page-item ${previousPageState}`}
                  onClick={(event) => goPreviousPage()}
                >
                  <a
                    className="page-link"
                    href="#"
                    tabIndex="-1"
                    aria-disabled={"true"}
                  >
                    <FaArrowLeft />
                  </a>
                </li>

                {pageButtons.map((item, index) => {
                  let page = pagingInfoRef.current.pageNumber();
                  let disabled =
                    page === item.pageNumber
                      ? "disabled disable-paging-btn"
                      : "";
                  return (
                    <li
                      key={index}
                      className={`page-item ${disabled}`}
                      onClick={(event) => goToPage(item.pageNumber)}
                    >
                      <a className="page-link" href="#">
                        {item.name}
                      </a>
                    </li>
                  );
                })}
                <li
                  className={`page-item ${nextPageState}`}
                  onClick={(event) => goNextPage()}
                >
                  <a className="page-link" href="#">
                    <FaArrowRight />
                  </a>
                </li>
              </ul>
            </nav>
          </div>*/}

          <div className="row">
            <Chart
              options={options}
              series={kpiData}
              type={chartType}
              height1={options.chart.height}
            />
          </div>
        </div>
      </div>
    </>
  );
}
